exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loginBox[data-v-c0811f50]{display:flex;align-items:center;justify-content:center;padding-top:40px;padding-bottom:40px;background-color:#f5f5f5}.form-signin[data-v-c0811f50]{width:100%;max-width:330px;padding:15px;margin:0 auto}.form-control[data-v-c0811f50]{position:relative;box-sizing:border-box;height:auto;padding:10px;font-size:16px}.form-control[data-v-c0811f50]:focus{z-index:2}input[type=text][data-v-c0811f50]{margin-bottom:-1px;border-bottom-right-radius:0;border-bottom-left-radius:0}input[type=password][data-v-c0811f50]{margin-bottom:10px;border-top-left-radius:0;border-top-right-radius:0}", ""]);

// exports
